module.exports = __webpack_public_path__ + "assets/devices/MC-302-ec6959a0ddf5f83752ef298a0b9515f0.svg";